export const defaultState = () => {
    return {
        saved: [],
    }
}

const state = defaultState()
export default state
